import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const KEY = "vv_member_token";
const AuthCtx = createContext(null);

export const useAuth = () => useContext(AuthCtx);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const AuthProvider = ({ children }) => {
  const [token, setTokenState] = useState(() => localStorage.getItem(KEY));
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const setToken = (t) => {
    if (t) localStorage.setItem(KEY, t); else localStorage.removeItem(KEY);
    setTokenState(t);
  };

  const hydrate = useCallback(async () => {
    const t = localStorage.getItem(KEY);
    try {
      const headers = t ? { Authorization: `Bearer ${t}` } : {};
      const { data } = await axios.get(`${API}/auth/me`, { headers, withCredentials: true });
      setUser(data);
      return data;
    } catch { setToken(null); setUser(null); }
    finally { setLoading(false); }
    return null;
  }, []);

  useEffect(() => { hydrate(); }, [hydrate]);

  const login = async (email, password) => {
    const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
    setToken(data.token);
    return (await hydrate()) || data;
  };
  const register = async (name, email, password) => {
    const { data } = await axios.post(`${API}/auth/register`, { name, email, password }, { withCredentials: true });
    setToken(data.token);
    return (await hydrate()) || data;
  };
  const logout = () => {
    axios.post(`${API}/auth/logout`, {}, { withCredentials: true }).catch(() => {});
    setToken(null); setUser(null);
  };
  const refresh = () => hydrate();
  const authAxios = () => {
    const t = localStorage.getItem(KEY);
    return axios.create({ baseURL: API, withCredentials: true, headers: t ? { Authorization: `Bearer ${t}` } : {} });
  };

  return (
    <AuthCtx.Provider value={{ user, loading, token, login, register, logout, refresh, authAxios }}>
      {children}
    </AuthCtx.Provider>
  );
};
